import ErrorMessage from "@/errors/ErrorMessage";
import HomepageCta from "../HomepageCta";
import {
  errorPanelCss,
  headlineCss,
  messageCss,
} from "./DistrictRestrictedContentError.style";

const DistrictRestrictedContentError = () => (
  <ErrorMessage
    headline={"This content isn't available"}
    data-qa-selector="district-restricted-content-error"
    __cssFor={{
      root: errorPanelCss,
      headline: headlineCss,
    }}
  >
    <p css={messageCss}>
      Visit the homepage to view the latest content or try using search.
    </p>
    <HomepageCta />
  </ErrorMessage>
);

export default DistrictRestrictedContentError;
